import { render, staticRenderFns } from "./ManageResources.vue?vue&type=template&id=31bae312&"
import script from "./ManageResources.vue?vue&type=script&lang=js&"
export * from "./ManageResources.vue?vue&type=script&lang=js&"
import style0 from "./ManageResources.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports